import { useUsers } from "@/http/api-hooks";
import type { Node as ProseMirrorNode } from "prosemirror-model";
import type { NodeView } from "prosemirror-view";
import { createRoot, type Root } from "react-dom/client";

function MentionPill({ userId }: { userId: number }) {
  const { data: users } = useUsers();
  const user = users?.find(u => u.id === userId);
  return <span className="mention-pill">@{user?.name ?? userId}</span>;
}

export class MentionNodeView implements NodeView {
  dom: HTMLElement;
  private root: Root;

  constructor(node: ProseMirrorNode) {
    this.dom = document.createElement("span");
    this.root = createRoot(this.dom);
    this.mount(node.attrs.userId as number);
  }

  private mount(userId: number) {
    this.root.render(<MentionPill userId={userId} />);
  }

  update(node: ProseMirrorNode) {
    if (node.type.name !== "mention") return false;
    this.mount(node.attrs.userId as number);
    return true;
  }

  destroy() {
    this.root.unmount();
  }

  stopEvent() {
    return true;
  }

  ignoreMutation() {
    return true;
  }
}
